import {useCallback} from 'react';
import {useQuery, UseQueryResult, useMutation, useQueryClient} from 'react-query';

import {getAgencyClients, syncAgencyClients} from 'client/common/utils/api-client';

import {AgencyClient} from 'client/common/types';

const AGENCY_CLIENTS_KEY = 'agency-clients';

export function useAgencyClients(): UseQueryResult<AgencyClient[]> {
    return useQuery(AGENCY_CLIENTS_KEY, async () => {
        const {data} = await getAgencyClients();

        return data;
    });
}

export function useSyncAgencyClients() {
    const queryClient = useQueryClient();
    const {mutateAsync} = useMutation(syncAgencyClients, {
        onMutate: async () => {
            await queryClient.cancelQueries(AGENCY_CLIENTS_KEY);

            const shapshot = queryClient.getQueryData(AGENCY_CLIENTS_KEY);

            queryClient.setQueryData(AGENCY_CLIENTS_KEY, undefined);

            return shapshot;
        },
        onSuccess: ({data}) => {
            queryClient.setQueryData(AGENCY_CLIENTS_KEY, data);
        },
        onError: (_error, _, shapshot) => {
            queryClient.setQueryData(AGENCY_CLIENTS_KEY, shapshot);
        }
    });

    return useCallback(async () => {
        await mutateAsync();
    }, [mutateAsync]);
}
